module.exports = __webpack_public_path__ + "img/IMG_0204-15_L_Wood.fddc76e1.jpg";